"use strict";

angular.module("core")
.controller("abstractStartEndDateTimeController", function($scope, $rootScope, $timeout, Language, moment, dateOnly) {
    var pickerFormat = dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm a";
    var unregister = Language.initializeController($scope, null, "locale");

    $scope.startDateOptions = {
        allowInputToggle: true,
        useCurrent: false,
        locale: $scope.locale,
        format: pickerFormat,
        sideBySide: true,
        toolbarPlacement: "bottom",
        showClose: true,
        showClear: true,
        icons: {
            close: "fa fa-check"
        }
    };

    $scope.endDateOptions = {
        allowInputToggle: true,
        useCurrent: false,
        locale: $scope.locale,
        format: pickerFormat,
        sideBySide: true,
        toolbarPlacement: "bottom",
        showClose: true,
        showClear: true,
        icons: {
            close: "fa fa-check"
        }
    };
    if (!dateOnly) {
        $scope.startDateOptions.stepping = 15;
        $scope.endDateOptions.stepping = 15;
    }

    this.getBeginningOfTheDay = function(reference) {
        return moment(reference).startOf('day');
    };

    this.getEndOfTheDay = function(reference) {
        return moment(reference).endOf('day');
    };

    this.getEndDateMin = function(reference) {
        return this.getBeginningOfTheDay(reference).add(1, "days");
    };

    this.updateStartDateMax = function(reference) {
        if (reference && typeof reference === "object" && reference.isValid()) {
            $scope.startDateOptions.maxDate = this.getBeginningOfTheDay(reference);
            $scope.startDateOptions.viewDate = this.startDateModel;
        } else {
            $scope.startDateOptions.maxDate = false;
        }
    };

    this.updateEndDateMin = function(reference) {
        if (reference && typeof reference === "object" && reference.isValid()) {
            if (dateOnly) {
                $scope.endDateOptions.minDate = this.getBeginningOfTheDay(reference);
            } else {
                $scope.endDateOptions.minDate = this.getEndDateMin(reference);
            }
            $scope.endDateOptions.viewDate = this.endDateModel;
        } else {
            $scope.endDateOptions.minDate = false;
        }
    };

    var unregisterLanguageChanged = $scope.$on("LanguageChanged", function(evt, newLocale, newLanguage) {
        $scope.startDateOptions.locale = newLocale;
        $scope.endDateOptions.locale = newLocale;
    });

    $scope.$on("$destroy", function() {
        unregister();
        unregisterLanguageChanged();
    });
});




//////////////////
// WEBPACK FOOTER
// ./core/start-end-date/abstract-start-end-date-time.controller.js
// module id = 454
// module chunks = 0